module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-wrapper",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container main-contents"
  }, [_vm._m(0), _c('router-view')], 1), _c('app-footer', {
    staticClass: "footer"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "commonAjaxLoading"
    }
  }, [_c('p', [_vm._v("loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d2be4b8a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app.pug
// module id = 919
// module chunks = 1